import React, { Component } from 'react'

import checkAuthentication from '../api/check-authentication'
import login from '../api/login'
import WithFooter from '../layout/WithFooter'
import SeatsEditor from '../components/SeatsEditor'


class SeatsEditingPage extends Component {

    componentDidMount() {
        checkAuthentication().then(
            result => result.json()
        ).then(result => {
            if (!result.is_authenticated) {
                let username = window.prompt("Username")
                let password = window.prompt("Password")
                return login(username, password)
            }
        }).then(result => {
            return checkAuthentication()
        }).then(
            result => result.json()
        ).then(result => {
            if (!result.is_authenticated) {
                window.location.replace('/not-found')
            }
        })
        .catch(error => {
            window.location.replace('/not-found')
        })
    }

    render() {
        return (
            <WithFooter>
                <SeatsEditor
                    performanceId={this.props.match.params.performanceId}
                    eventId={this.props.match.params.eventId}
                    />
            </WithFooter>
        )
    }
}

export default SeatsEditingPage;
